import { render, staticRenderFns } from "./GiftRow.vue?vue&type=template&id=5f4a8a5a&scoped=true"
import script from "./GiftRow.vue?vue&type=script&lang=js"
export * from "./GiftRow.vue?vue&type=script&lang=js"
import style0 from "./GiftRow.vue?vue&type=style&index=0&id=5f4a8a5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4a8a5a",
  null
  
)

export default component.exports